/**
 * The client's order list: the tabs' filter and a status's words. Kept from
 * the old `data/mockOrders.js` (2 Oct 2026), whose sample orders nothing showed.
 */

export function filterOrders(orders, filter) {
  if (filter === 'all') return orders;
  if (filter === 'active') return orders.filter((o) => o.status === 'active' || o.status === 'transit');
  if (filter === 'delivered') return orders.filter((o) => o.status === 'delivered');
  if (filter === 'cancelled') return orders.filter((o) => o.status === 'cancelled');
  return orders;
}

export function statusLabel(s) {
  if (s === 'delivered') return 'Delivered';
  if (s === 'transit') return 'In Transit';
  if (s === 'cancelled') return 'Cancelled';
  if (s === 'active') return 'Active';
  return s;
}
